import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SubSection, SubSectionTitle } from './styles';

const Container = styled.ul`
  list-style: none;
  padding: 0;
`;

const Point = styled.li`
  display: flex;
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 19px;
  line-height: 120%;
  margin-bottom: 16px;

  ${props => props.theme.isXXLarge && `
    line-height: 130%;
  `};

  &:before {
    content: "•";
    font-size: 32px;
    color: ${props => props.theme.secondaryColor};
    padding-right: 24px;
  }
`;

export default function InvestmentPhilosophy({ investmentPhilosophy }) {
  const nonEmptyPhilosophy = _.compact(investmentPhilosophy.map(value => value.trim()));

  if (nonEmptyPhilosophy.length === 0) {
    return null;
  }

  return (
    <SubSection>
      <SubSectionTitle>Investment Philosophy</SubSectionTitle>
      <Container>
        {nonEmptyPhilosophy.map((value, index) => (<Point key={`point-${index + 1}`}>{value}</Point>))}
      </Container>
    </SubSection>
  );
}

InvestmentPhilosophy.propTypes = {
  investmentPhilosophy: PropTypes.arrayOf(PropTypes.string).isRequired,
};
